import { QueryFunction } from '@tanstack/react-query';
import {
  LOConfiguration,
  LOConfigurationResponse,
} from 'src/types/configurations';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getLOConfiguration: QueryFunction<
  LOConfiguration,
  ['/configurations/LO']
> = async () => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<LOConfigurationResponse>(
    '/configurations/LoanIngestionFields',
    {
      method: 'GET',
    },
  );

  if (response.data) return response.data.configuration;
  throw new Error('Failed to fetch LO configuration');
};

export default getLOConfiguration;
